export enum ReportCategoryQuery {
  SUMMARY = 'summary-',
  COMMENT = 'comment-',
}
